export interface ProfileFact {
  label: string;
  value: string;
}

export interface TimelineItem {
  year: string;
  title: string;
  description: string;
}

export const profile = {
  name: "翔田千里",
  nameKana: "しょうだ ちさと",
  nameEn: "Shoda Chisato",
  tagline: "以克制见长的影视演员",
  intro:
    "翔田千里，日本影视演员。以细腻、克制、极少外露的表演风格为人熟知，作品横跨电影与电视剧，擅长在安静的场景中完成人物的转折。近年的代表作包括《潮汐之信》《白色回廊》与《夜行列车》。",
  portrait:
    "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20poised%20East%20Asian%20woman%20in%20her%20thirties%20wearing%20a%20minimal%20dark%20navy%20coat%2C%20soft%20warm%20amber%20side%20light%2C%20deep%20navy%20studio%20background%2C%20calm%20confident%20expression%2C%20cinematic%20film%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=800&height=1000&seq=profile-portrait-main&orientation=portrait",
  portraitAlt:
    "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20moment%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20dark%20coat%20standing%20on%20a%20quiet%20film%20set%20with%20warm%20amber%20practical%20lights%20and%20deep%20navy%20shadows%2C%20soft%20focus%20background%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=profile-portrait-second&orientation=landscape",
  facts: [
    { label: "出生日期", value: "1988 年 3 月 12 日" },
    { label: "国籍", value: "日本" },
    { label: "出生地", value: "神奈川县横滨市" },
    { label: "身高", value: "165 cm" },
    { label: "血型", value: "A 型" },
    { label: "出道年份", value: "2010 年" },
    { label: "职业", value: "影视演员" },
    { label: "擅长语言", value: "日语、英语" },
  ] as ProfileFact[],
  representativeWorks: ["潮汐之信", "白色回廊", "静默的证词", "夜行列车"],
  careerIntro:
    "2010 年，翔田千里通过独立电影《海雾之下》正式进入影视行业，最初以短片与舞台剧为主。2015 年凭《初雪记》获得广泛关注，此后陆续与黑泽和树、白石凛、森田圭等导演合作，逐步确立以克制表演为核心的戏路。近五年，她有意放慢作品节奏，平均每年只接一到两部，并把大量时间用于剧本研读与现场观察。",
  approach: [
    {
      title: "把情绪留在镜头之外",
      description:
        "她习惯在开拍前把人物的前史写完，却很少在镜头前完整表达。她认为观众看到的应该是结果，而不是准备的痕迹。",
    },
    {
      title: "依赖现场，而不是技巧",
      description:
        "从《潮汐之信》的海岛生活，到《白色回廊》的医院观察，她倾向于用真实的职业经验替换表演技巧。",
    },
    {
      title: "给剪辑留空间",
      description:
        "在多部作品的采访中她都提到，演员的工作是提供素材，「剩下的交给剪辑与观众」。",
    },
  ],
  timeline: [
    {
      year: "2010",
      title: "独立电影出道",
      description: "出演短片《海雾之下》，正式进入影视行业，同年参与两部舞台剧演出。",
    },
    {
      year: "2015",
      title: "《初雪记》获得关注",
      description: "首次担任电影主演，凭长谷川雪一角进入观众视野。",
    },
    {
      year: "2018—2019",
      title: "稳定的电影与剧集双线",
      description: "先后出演《归途七日》《北纬三十五度》，并凭《灯下之人》拓宽群像剧表演经验。",
    },
    {
      year: "2021",
      title: "《静默的证词》",
      description: "挑战大量手语与法庭长镜头，被评论认为是其表演方法的集中呈现。",
    },
    {
      year: "2023",
      title: "《潮汐之信》与《白色回廊》",
      description: "同年推出两部主演作品，分别在大银幕与剧集领域获得高度评价。",
    },
    {
      year: "2024",
      title: "《夜行列车》",
      description: "与黑泽和树再度合作，以极简对白完成一次关于记忆与等待的演出。",
    },
  ] as TimelineItem[],
  honors: [
    { year: "2024", title: "年度电视剧评选 最佳女主角（提名）", work: "《静默的证词》" },
    { year: "2023", title: "亚洲电影展 当代视野单元 入围", work: "《潮汐之信》" },
    { year: "2022", title: "年度剧集评论奖 最佳女主角", work: "《静默的证词》" },
    { year: "2019", title: "独立影像赏 评审团特别提及", work: "《归途七日》" },
  ],
};